import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonCol, IonLabel } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { PayrollUnitName } from '@wilson/interfaces';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { WorktimeMetricsCardComponent } from '../worktime-metrics-card/worktime-metrics-card.component';
import { WorkingTimeDashboardContextService } from '../working-time-dashboard/working-time-dashboard-context.service';
import { WorkingTimeStatsService } from './working-time-stats.service';

@Component({
  selector: 'wilson-working-time-cards',
  templateUrl: './working-time-cards.component.html',
  styleUrls: ['./working-time-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    TranslatePipe,
    WorktimeMetricsCardComponent,
    SectionWrapperComponent,
    IonLabel,
    IonCol,
  ],
})
export class WorkingTimeCardsComponent {
  private readonly dashboardContext = inject(
    WorkingTimeDashboardContextService,
  );
  private readonly workingTimeStatsService = inject(WorkingTimeStatsService);

  protected readonly PayrollUnitName = PayrollUnitName;
  protected readonly monthYear = this.dashboardContext.monthYear;
  protected readonly currentMonth = this.workingTimeStatsService.currentMonth;
  protected readonly worktimeStats = this.workingTimeStatsService.worktimeStats;
  protected readonly futureWorkTimeStats$ =
    this.workingTimeStatsService.futureWorkTimeStats$;
  protected readonly loadingWorktimeStatsSignal =
    this.workingTimeStatsService.loadingWorktimeStats;
  protected readonly loadingFutureWorkTimeStatsSignal =
    this.workingTimeStatsService.loadingFutureWorkTimeStats;
}
